module.exports = __webpack_public_path__ + "static/media/defaultUsr.1bd2c245.svg";